import axios from "axios";
import { isNone } from "./OtherService";
import defaultLang from "../config";

export const baseurl = process.env.REACT_APP_URL;

//La liste des actualités
export async function listactualite(page="1", titre="", categorie = "", dateDebut="", dateFin="", type="", limit="6") {
  const lang = JSON.parse(localStorage.getItem('lang')) || defaultLang;

  var url = baseurl + "communiques/users?limit="+limit+"&page="+page+"&titre="+titre;
  if(!isNone(categorie)) url = url + "&theme="+categorie;
  if(!isNone(dateDebut)) url = url + "&datedebut="+dateDebut;
  if(!isNone(dateFin)) url = url + "&datefin="+dateFin;
  if(!isNone(lang)) url = url + '&lang=' + lang.idlanguage;
  if(!isNone(type)){
    // si c'est un cdp
    if(type=="0") url = url + "&com=1";
    // si c'est un article
    else if(type=="1") url = url + "&article=1";
  }else{
    url = url + "&com=1&article=1"
  }
  
  var retour = null;

  await axios
    .get(url)
    .then(function (response) {
      retour = response;
    })
    .catch(function (error) {
      retour = error.response;
    });

  return retour;
}

//Information d'une actualité
export async function getoneactualite(idactualite) {
  
  var url = baseurl + "communiques/" + idactualite;

  var retour = null;

  await axios
    .get(url)
    .then(function (response) {
      retour = response;
    })
    .catch(function (error) {
      retour = error.response;
    });

  return retour;
}


export async function getoneactualitebyslug(slug) {
  
  var url = baseurl + "communiques/slug/" + slug;

  var retour = null;

  await axios
    .get(url)
    .then(function (response) {
      retour = response;
    })
    .catch(function (error) {
      retour = error.response;
    });

  return retour;
}
